<template>
  <DsfFormControlBox
    class="ds-date-picker"
    :owner="_self"
    :block-class="{ 'ds-error-border': errors.length > 0 }"
  >
    <template v-slot:simple>
      <span :title="getShowContent() | proxy(formatter)">{{getShowContent() | proxy(formatter)}}</span>
      <slot name="error">
        <div
          v-if="errors.length > 0"
          class="ds-error-text"
        >
          {{ errorsMsg }}
        </div>
      </slot>
    </template>
    <template v-slot:content>
      <ds-date-picker
        v-if="!readOnly"
        v-model="value2"
        :type="pickerType"
        :period-type="chooseType"
        :format="format"
        :value-format="valueFormat"
        :picker-options="mPicker || pickerOptions"
        :disabled="disabled"
        :clearable="clearable"
        popperClass="ds-date-picker-panel"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
      >
      </ds-date-picker>
      <!--只读状态只显示div-->
      <div
        v-else-if="readOnly"
        class="ds-form-readonly"
      >
        <span :title="getShowContent() | proxy(formatter)">{{
          getShowContent() | proxy(formatter)
        }}</span>
      </div>
      <slot name="error">
        <div
          v-if="errors.length > 0"
          class="ds-error-text"
        >
          {{ errorsMsg }}
        </div>
      </slot>
    </template>
  </DsfFormControlBox>
</template>
<script>
import dateMixin from "./dateMixin";
import { createDatePicker } from "./date-picker";

const ElDatePicker = ELEMENT.DatePicker;
const DsDatePicker = createDatePicker(ElDatePicker);

export default dsf.component({
  name: "DsfPeriodPicker",
  mixins: [$mixins.formControl, dateMixin],
  ctrlCaption: "季年旬",
  components: {
    DsDatePicker,
  },
  props: {
    chooseType: {
      type: String,
      default: "MD",
    },
    value: {
      type: [String, Array, Date],
      default: "",
    },
    range: {
      type: Boolean,
      default: false,
    },
    // 是否显示清除按钮
    clearable: {
      type: Boolean,
      default: true,
    },
    //用于二次开发的 pickerOptions
    mPicker: {
      type: Object,
      required: false,
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("date-picker-meta-data");
      },
    },
  },
  data() {
    return {
      // 本地写死
      formats: {
        HY: "yyyy-MM",
        SS: "yyyy-MM",
        MD: "yyyy-MM-dd",
      },
      valueFormats: {
        HY: "yyyy-MM-dd HH:mm:ss",
        SS: "yyyy-MM-dd HH:mm:ss",
        MD: "yyyy-MM-dd HH:mm:ss",
      },
      val: this.value,
    };
  },
  watch: {
    value(to, ov) {
      this.initValue(to);
    },
  },
  computed: {
    format() {
      return this.formats[this.chooseType];
    },
    valueFormat() {
      return this.valueFormats[this.chooseType];
    },
    pickerType() {
      // if (this.range) {
      //   return 'monthrange';
      // }
      if (this.chooseType == "MD") {
        return "date";
      }
      return "month";
    },
    value2: {
      get() {
        return this.value;
      },
      set(nv) {
        let v = nv || null;
        this.emitValueChange(v);
      },
    },
  },
  methods: {
    initValue(v) {
      this.value2 = v;
    },
  },
});
</script>
